import { Avatar, Flex, Layout, Typography } from 'antd';
import React from 'react';
import classes from './Header.module.scss';

import { BellOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import clsx from 'clsx';
import { useGetAvatarQuery } from 'entities/user';
import { useLogoutMutation } from 'entities/user/api';
import { Link, useNavigate } from 'react-router-dom';
import { ROUTES } from 'shared/const/routes';


interface HeaderProps extends React.ComponentProps<typeof Layout.Header> {
  className?: string;
}

const Header: React.FC<HeaderProps> = (props) => {
  const navigate = useNavigate();
  const [logout] = useLogoutMutation();
  const { data: avatarUrl } = useGetAvatarQuery();


  const onLogout = async () => {
    try {
      await logout();
      navigate(ROUTES.LOGIN.path);
    } catch (error) {
      console.error('Logout failed:', error);
    }

  };

  return (
    <Layout.Header
      {...props}
      className={clsx(classes.container, props.className)}>
      <Link to={ROUTES.DASHBOARD.path}>
        <div className={classes.titleContainer}>
          <Typography.Text id="header-logo" className={classes.title}>
            {'Weststein'}
          </Typography.Text>
        </div>
      </Link>
      <Flex gap={16} align="center">
        <Link
          id="btn__notifications"
          to={ROUTES.NOTIFICATIONS.path}
          className={classes.button}>
          <BellOutlined />
        </Link>
        <Link to={ROUTES.PROFILE.path} className={classes.centered}>
          <Avatar
            src={avatarUrl ?? undefined}
            icon={!avatarUrl ? <UserOutlined /> : undefined}
            size={48}
          />
        </Link>
        <Flex id="btn__logout" onClick={onLogout} className={classes.button}>
          <LogoutOutlined />
        </Flex>
      </Flex>
    </Layout.Header>
  );
};

export default Header;
